function urlContainsDomain(url: string, domain: string): boolean {
  try {
    const hostname = new URL(url).hostname;
    return hostname.includes(domain);
  } catch {
    return false;
  }
}

function getBaseDomain(hostname: string): string {
  const parts = hostname.split('.');
  return parts.slice(-2).join('.');
}

export function getPublicHostUrl(): string {
  const currentDomain = window.location.hostname;

  // Define your public host URLs
  const PUBLIC_HOST_URL = process.env.PUBLIC_HOST_URL || '';
  const PUBLIC_HOST_URL_NEW = process.env.PUBLIC_HOST_URL_NEW || '';

  const currentBaseDomain = getBaseDomain(currentDomain);
  if (urlContainsDomain(PUBLIC_HOST_URL_NEW, currentBaseDomain)) {
    return PUBLIC_HOST_URL_NEW;
  } else {
    return PUBLIC_HOST_URL;
  }
}

export function getLandingPageUrl(): string {
  const currentDomain = window.location.hostname;

  // Define your public host URLs
  const LANDING_PAGE_URL = process.env.LANDING_PAGE_URL || '';
  const LANDING_PAGE_URL_NEW = process.env.LANDING_PAGE_URL_NEW || '';

  const currentBaseDomain = getBaseDomain(currentDomain);
  if (urlContainsDomain(LANDING_PAGE_URL_NEW, currentBaseDomain)) {
    return LANDING_PAGE_URL_NEW;
  } else {
    return LANDING_PAGE_URL;
  }
}

export const LANDING_PAGE_URL = getLandingPageUrl();
export const PUBLIC_HOST_URL = getPublicHostUrl();
